import { IHeadersObject } from "global";
import isEmpty from "lodash/isEmpty";
import React, { memo } from "react";
import { frontloadConnect } from "react-frontload";
import { connect } from "react-redux";
import {
    getMenuData,
    getSSRHeaders,
    isMenuFetching as _isMenuFetching,
} from "shared/store/app/selectors";
import { fetchMenuData as _fetchMenuData } from "shared/store/app/services";
import { I18FetchData } from "shared/store/internationalization/services";

interface IApiStateProps {
    isMenuFetching: boolean;
    menuData: any;
    hasUpdatedI18n: boolean;
    cookies: {
        [key: string]: string;
    };
}

interface IApiDispatchProps {
    fetchMenuData: () => Promise<void>;
    fetchI18NData: typeof I18FetchData;
}

interface IApiProps extends IApiStateProps, IApiDispatchProps {
    children: React.ReactNode;
    ssrHeaders: IHeadersObject;
}

function Api({ children, isMenuFetching = true }: IApiProps) {
    if (isMenuFetching) {
        return null;
    }

    return <>{children}</>;
}

const mapStateToProps = (state: any) => ({
    isMenuFetching: _isMenuFetching(state),
    menuData: getMenuData(state),
    cookies: state.app.cookies,
    hasUpdatedI18n: state.internationalization.hasUpdatedI18n,
    ssrHeaders: getSSRHeaders(state),
});

const mapDispatchToProps = {
    fetchMenuData: _fetchMenuData,
    fetchI18NData: I18FetchData,
};

const fetchData = ({
    fetchMenuData,
    menuData,
    cookies,
    hasUpdatedI18n,
    fetchI18NData,
    ssrHeaders,
}: IApiProps) => {
    if (isEmpty(menuData) === false && hasUpdatedI18n) {
        return Promise.resolve();
    }

    const headers = __SERVER__ ? ssrHeaders : {};
    const promises = [];
    promises.push(isEmpty(menuData) ? fetchMenuData() : Promise.resolve());
    promises.push(
        hasUpdatedI18n === false
            ? fetchI18NData({
                  defaultCurrency: cookies.CurrencyCode,
                  defaultCountry: cookies.countryName,
                  ssrHeaders: headers,
              })
            : Promise.resolve()
    );

    return Promise.all(promises);
};

export default connect<IApiStateProps, IApiDispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(frontloadConnect(fetchData)(memo(Api)));
